import React, { useState } from 'react';
import PasswordStrength, { validatePassword } from '../../PasswordStrength/PasswordStrength';

const AccountStep = ({ formData, onNext, isFirstStep }) => {
  const [localData, setLocalData] = useState({
    email: formData.email || '',
    password: formData.password || '',
    fullName: formData.fullName || '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};

    // Full Name
    if (!localData.fullName.trim()) {
      newErrors.fullName = 'Full name is required';
    } else if (localData.fullName.trim().length < 2) {
      newErrors.fullName = 'Full name must be at least 2 characters';
    }

    // Email
    if (!localData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(localData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    // Password
    const passwordValidation = validatePassword(localData.password);
    if (!localData.password) {
      newErrors.password = 'Password is required';
    } else if (!passwordValidation.isValid) {
      newErrors.password = 'Password does not meet requirements';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      onNext(localData);
    }
  };

  return (
    <div className="wizard-step">
      <h2 className="step-title">Create Your Account</h2>
      <p className="step-subtitle">Enter your details to get started</p>

      <form onSubmit={handleSubmit}>
        {/* Full Name */}
        <div className="wizard-field">
          <label htmlFor="fullName">
            Full Name
            <span className="required-asterisk">*</span>
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            className={`wizard-input ${errors.fullName ? 'has-error' : ''}`}
            value={localData.fullName}
            onChange={handleChange}
            placeholder="Enter your full name"
            autoComplete="name"
          />
          {errors.fullName && <div className="field-error">{errors.fullName}</div>}
        </div>

        {/* Email */}
        <div className="wizard-field">
          <label htmlFor="email">
            Email
            <span className="required-asterisk">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className={`wizard-input ${errors.email ? 'has-error' : ''}`}
            value={localData.email}
            onChange={handleChange}
            placeholder="Enter your email address"
            autoComplete="email"
          />
          {errors.email && <div className="field-error">{errors.email}</div>}
        </div>

        {/* Password */}
        <div className="wizard-field">
          <label htmlFor="password">
            Password
            <span className="required-asterisk">*</span>
          </label>
          <div className="password-field-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              name="password"
              className={`wizard-input ${errors.password ? 'has-error' : ''}`}
              value={localData.password}
              onChange={handleChange}
              placeholder="Create a password"
              autoComplete="new-password"
            />
            <button
              type="button"
              className="password-toggle"
              onClick={() => setShowPassword(!showPassword)}
            >
              <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
            </button>
          </div>
          {errors.password && <div className="field-error">{errors.password}</div>}
          <PasswordStrength password={localData.password} />
        </div>

        {/* Navigation */}
        <div className="wizard-navigation">
          <div className="wizard-btn-spacer" />
          <button type="submit" className="wizard-btn wizard-btn-next">
            Next
            <i className="bi bi-arrow-right"></i>
          </button>
        </div>
      </form>
    </div>
  );
};

export default AccountStep;
